import Grid from 'atoms/Layout/Grid/Grid';
import React from 'react';
import CallToActionCardVertical from 'src/app/molecules/CallToAction/CallToActionCardVertical';

const GettingStartedWithAI = (): JSX.Element => (
  <Grid
    padding={['spacing-none', 'spacing-4xl']}
    paddingSm={['spacing-none', 'spacing-xl']}
    totalColumns={1}
  >
    <CallToActionCardVertical
      headline={{
        type: 'heading',
        size: '2xl',
        text: 'Getting started is fast and fun with AI',
      }}
      description={{
        type: 'paragraph',
        size: 'xl',
        text: 'Who are you bringing together? Let’s build their new home together.',
      }}
      inputProps={{
        placeholder: 'Who do you want to bring together?',
        hint: 'Examples: coaching clients, meditation novices, vegan chefs, dog lovers, aspiring entrepreneurs, etc.',
      }}
    />
  </Grid>
);

export default GettingStartedWithAI;
